import { render, staticRenderFns } from "./AddExitRegister.vue?vue&type=template&id=1b187a29"
import script from "./AddExitRegister.vue?vue&type=script&lang=js"
export * from "./AddExitRegister.vue?vue&type=script&lang=js"
import style0 from "./AddExitRegister.vue?vue&type=style&index=0&id=1b187a29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports